export default ({ FONT_SIZES }) => ({
  container: {
    ...FONT_SIZES.HEADING_BIG.STYLE
  }
})
